var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExpiredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.12 16.3333L27.4133 14.0533H27.3867C28.6142 12.7814 29.2868 11.0743 29.2568 9.3069C29.2268 7.53949 28.4966 5.85622 27.2267 4.62667C25.9826 3.42692 24.3217 2.75652 22.5933 2.75652C20.865 2.75652 19.2041 3.42692 17.96 4.62667L15.6667 6.90667",
    stroke: "#FB2C36",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.89333 15.6667L4.61333 17.9467C3.38583 19.2186 2.71323 20.9257 2.74323 22.6931C2.77323 24.4605 3.50337 26.1438 4.77333 27.3733C6.0174 28.5731 7.67834 29.2435 9.40667 29.2435C11.135 29.2435 12.7959 28.5731 14.04 27.3733L16.32 25.0933",
    stroke: "#FB2C36",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6667 2.66667V6.66667",
    stroke: "#FB2C36",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.66667 10.6667H6.66667",
    stroke: "#FB2C36",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.3333 25.3333V29.3333",
    stroke: "#FB2C36",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.3333 21.3333H29.3333",
    stroke: "#FB2C36",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExpiredIcon);
export default __webpack_public_path__ + "static/media/link-expired-icon.433c269c474b7a8d83a9a63e8bacb037.svg";
export { ForwardRef as ReactComponent };